import styles from './HomePage.module.css';
import homeLogo from '../../assets/homeLogo2.png';

const HomePage = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          QCrypt
          <br />
          <p className={styles.subtitle}>2025</p>
        </div>
      </div>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={homeLogo} alt="Home Logo" />
      </div>
    </div>
  );
};

export default HomePage;
